export default __webpack_public_path__ + "static/media/IconAppStoreWhite.3f380c65.svg";